// Generated by ts-to-zod
import { z } from "zod";
const allowedValuesMediaSchema = z.object({
    media: z
        .object({
        id: z.string(),
        url: z.string(),
        title: z.string(),
        mimeType: z.string(),
    })
        .nullable(),
});
const allowedValuesMediaStrictSchema = z.object({
    media: z
        .object({
        id: z.string(),
        url: z.string(),
        title: z.string(),
        mimeType: z.string(),
    })
});
export const props2AllowedValuesNumberSchema = z
    .object({
    allowedNumber: z.number(),
})
    .and(allowedValuesMediaSchema);
export const props2AllowedValuesTextSchema = z
    .object({
    allowedText: z.string(),
})
    .and(allowedValuesMediaSchema);
export const props2ValuesMediaBoolSchema = z
    .object({
    bool: z.boolean(),
})
    .and(allowedValuesMediaStrictSchema);
export const props2NumberRangeSchema = z.object({
    min: z.number().nullable(),
    max: z.number().nullable(),
});
export const props2NumberUnitSchema = z.string();
export const props2TextComputedSchema = z.object({
    kind: z.literal("Props2TextComputed"),
    key: z.string(),
    label: z.string(),
    expr: z.string(),
    group: z.string(),
    clientVisibility: z.boolean(),
});
export const props2TextArrayComputedSchema = z.object({
    kind: z.literal("Props2TextArrayComputed"),
    key: z.string(),
    label: z.string(),
    expr: z.string(),
    group: z.string(),
    clientVisibility: z.boolean(),
});
export const props2BoolComputedSchema = z.object({
    kind: z.literal("Props2BoolComputed"),
    key: z.string(),
    label: z.string(),
    expr: z.string(),
    group: z.string(),
    clientVisibility: z.boolean(),
});
export const props2NumberComputedSchema = z.object({
    kind: z.literal("Props2NumberComputed"),
    key: z.string(),
    label: z.string(),
    expr: z.string(),
    unit: props2NumberUnitSchema.nullable(),
    group: z.string(),
    clientVisibility: z.boolean(),
});
export const props2NumberArrayComputedSchema = z.object({
    kind: z.literal("Props2NumberArrayComputed"),
    key: z.string(),
    label: z.string(),
    expr: z.string(),
    unit: props2NumberUnitSchema.nullable(),
    group: z.string(),
    clientVisibility: z.boolean(),
});
export const props2ComputedSchema = z.union([
    props2TextComputedSchema,
    props2NumberComputedSchema,
    props2TextArrayComputedSchema,
    props2NumberArrayComputedSchema,
    props2BoolComputedSchema,
]);
export const props2BoolComputedEvaluatedSchema = props2BoolComputedSchema.and(z.object({
    missingValue: z.boolean(),
    valueBoolComputed: z.boolean().nullable(),
    aliasedExpr: z.string(),
}));
export const props2NumberComputedEvaluatedSchema = props2NumberComputedSchema.and(z.object({
    missingValue: z.boolean(),
    valueNumberComputed: z.number().nullable(),
    aliasedExpr: z.string(),
}));
export const props2NumberArrayComputedEvaluatedSchema = props2NumberArrayComputedSchema.and(z.object({
    missingValue: z.boolean(),
    valueNumberArrayComputed: z.array(z.number()).nullable(),
    aliasedExpr: z.string(),
}));
export const props2TextComputedEvaluatedSchema = props2TextComputedSchema.and(z.object({
    missingValue: z.boolean(),
    valueTextComputed: z.string().nullable(),
    aliasedExpr: z.string(),
}));
export const props2TextArrayComputedEvaluatedSchema = props2TextArrayComputedSchema.and(z.object({
    missingValue: z.boolean(),
    valueTextArrayComputed: z.array(z.string()).nullable(),
    aliasedExpr: z.string(),
}));
const askWhenSchema = z.enum([
    "onQuoteCreate",
    "onQuoteRefinement",
    "onQuoteRefinement2",
    "onQuoteRefinement3",
    "onEmbeddableWizard",
    "onCallAssistant"
]);
const askWhomSchema = z.enum(["contractee", "contractor"]);
const questionControlSchema = z.object({
    askWhen: askWhenSchema.array(),
    askWhom: askWhomSchema.array()
}).array();
export const props2AskWhenSchema = askWhenSchema;
export const props2AskWhomSchema = askWhomSchema;
export const props2NumberSchema = z.object({
    kind: z.literal("Props2Number"),
    key: z.string(),
    label: z.string(),
    valueNumber: z.number().nullable(),
    allowedValuesNumber: z.array(props2AllowedValuesNumberSchema),
    range: props2NumberRangeSchema.nullable(),
    unit: props2NumberUnitSchema.nullable(),
    step: z.number().nullable().default(null),
    essential: z.boolean(),
    group: z.string(),
    clientVisibility: z.boolean(),
    prompt: z.string(),
    questionControl: questionControlSchema,
    customizable: z.boolean()
});
export const props2TextSchema = z.object({
    kind: z.literal("Props2Text"),
    key: z.string(),
    label: z.string(),
    valueText: z.string().nullable(),
    allowedValuesText: z.array(props2AllowedValuesTextSchema),
    essential: z.boolean(),
    group: z.string(),
    clientVisibility: z.boolean(),
    prompt: z.string(),
    questionControl: questionControlSchema,
    customizable: z.boolean()
});
export const props2NumberArraySchema = z.object({
    kind: z.literal("Props2NumberArray"),
    key: z.string(),
    label: z.string(),
    valueNumberArray: z.array(z.number()).nullable(),
    allowedValuesNumber: z.array(props2AllowedValuesNumberSchema),
    range: props2NumberRangeSchema.nullable(),
    unit: props2NumberUnitSchema.nullable(),
    step: z.number().nullable().default(null),
    essential: z.boolean(),
    group: z.string(),
    clientVisibility: z.boolean(),
    prompt: z.string(),
    questionControl: questionControlSchema,
    customizable: z.boolean()
});
export const props2TextArraySchema = z.object({
    kind: z.literal("Props2TextArray"),
    key: z.string(),
    label: z.string(),
    valueTextArray: z.array(z.string()).nullable(),
    allowedValuesText: z.array(props2AllowedValuesTextSchema),
    essential: z.boolean(),
    group: z.string(),
    clientVisibility: z.boolean(),
    prompt: z.string(),
    questionControl: questionControlSchema,
    customizable: z.boolean()
});
export const props2BoolSchema = z.object({
    kind: z.literal("Props2Bool"),
    key: z.string(),
    label: z.string(),
    valueBool: z.boolean().nullable(),
    valuesMediaBool: z.array(props2ValuesMediaBoolSchema),
    essential: z.boolean(),
    group: z.string(),
    clientVisibility: z.boolean(),
    prompt: z.string(),
    questionControl: questionControlSchema,
    customizable: z.boolean()
});
export const props2Schema = z.union([
    props2NumberSchema,
    props2TextSchema,
    props2BoolSchema,
    props2NumberArraySchema,
    props2TextArraySchema,
    props2TextComputedSchema,
    props2NumberComputedSchema,
    props2BoolComputedSchema,
    props2NumberArrayComputedSchema,
    props2TextArrayComputedSchema,
]);
export const props2NonComputedSchema = z.union([
    props2TextSchema,
    props2NumberSchema,
    props2BoolSchema,
    props2NumberArraySchema,
    props2TextArraySchema,
]);
export const props2NonComputeDefinitionSchema = z.union([
    props2BoolSchema.pick({ key: true, kind: true }),
    props2NumberSchema.pick({
        key: true,
        kind: true,
        allowedValuesNumber: true,
        range: true,
        unit: true,
    }),
    props2TextSchema.pick({ key: true, kind: true, allowedValuesText: true }),
    props2TextArraySchema.pick({
        key: true,
        kind: true,
        allowedValuesText: true,
    }),
    props2NumberArraySchema.pick({
        key: true,
        kind: true,
        allowedValuesNumber: true,
        range: true,
        unit: true,
    }),
]);
export const propsWithEvaluatedValuesSchema = z.union([
    props2TextSchema,
    props2NumberSchema,
    props2NumberArraySchema,
    props2TextArraySchema,
    props2BoolSchema,
    props2BoolComputedEvaluatedSchema,
    props2NumberComputedEvaluatedSchema,
    props2NumberArrayComputedEvaluatedSchema,
    props2TextComputedEvaluatedSchema,
    props2TextArrayComputedEvaluatedSchema,
]);
//# sourceMappingURL=props2-zod-schema.generated.js.map